export default {"src":"/_next/static/media/exclamation.e022a605.svg","height":10,"width":10,"blurWidth":0,"blurHeight":0};